import { Box, Divider, Flex } from "@chakra-ui/react";
import { Sidebar } from "@root/components/dashboard/sidebar";
import { Header } from "@root/components/dashboard/header";
import React from "react";
import { Outlet } from "react-router-dom";
import { DashboardLayoutContainter } from "./styles";
import { useDispatch, useSelector } from "react-redux";
import { filePopOverHandler } from "@root/store/slices/entities";
import { getFilePopOver } from "@root/store/selectors/entities";
import SectionHeader from "@root/components/section-header/sectionheader";
import { TopHeader } from "@root/components/DashboardTopHeader/topheader";
import { AlertWrapper } from "@root/components";

const DashboardLayout: React.FC = () => {
  const dispatch = useDispatch();
  const filePopOverStatus: boolean = useSelector(getFilePopOver);
  const globalClickHandlet = () => {
    if (filePopOverStatus) {
      dispatch(filePopOverHandler(false));
    }
  };
  const handleSearch = (query: string) => {
    console.log("Search query:", query);
    // Implement search functionality here
  };

  const handleNotificationClick = () => {
    console.log("Notification clicked");
    // Implement notification functionality here
  };

  const handleHelpClick = () => {
    console.log("Help clicked");
    // Implement help functionality here
  };

  return (
    <AlertWrapper>
      <DashboardLayoutContainter onClick={globalClickHandlet}>
        <Flex flex={1} width={"100%"}>
          <Box className="left-box" borderRight={"1px solid #CDD6DC"}>
            <Sidebar />
          </Box>
          <Flex flex={1} direction="column" className="right-box">
            <Header
              onSearch={handleSearch}
              onNotificationClick={handleNotificationClick}
              onHelpClick={handleHelpClick}
            />
            <Box overflow={"auto"} flex={1} bgColor={"white"}>
              <Outlet />
            </Box>
          </Flex>
        </Flex>
      </DashboardLayoutContainter>
    </AlertWrapper>
  );
};

export default DashboardLayout;
